import { render, staticRenderFns } from "./ReceiptData.vue?vue&type=template&id=cc677f50&"
import script from "./ReceiptData.vue?vue&type=script&lang=js&"
export * from "./ReceiptData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports